(function() {
    'use strict';

    angular.module('app').factory('GoogleMapService', GoogleMapService);

    function GoogleMapService() {
        var map = null;
        var control = null;

        return {
            defaults: defaults,
            reset: reset,
            set: set,
            get: get,
            ready: ready,
            panTo: panTo,
            extend: extend,
            getZoom: getZoom,
            setZoom: setZoom,
            getScale: getScale,
            getOffset: getOffset,
            latLngToPoint: latLngToPoint,
            getBounds: getBounds,
            getWindowOffset: getWindowOffset,
        };

        function reset() {
            map = null;
            control = null;
        }

        function ready() {
            return map !== null;
        }

        function getZoom() {
            return map.zoom;
        }

        function setZoom(zoom) {
            map.zoom = zoom;
        }

        function extend(list) {
            var n;
            var s;
            var w;
            var e;

            if (!list.length) {
                return;
            }

            list.map(function(o) {
                if (!o.lat && !o.lng) {
                    return;
                }
                if (typeof n === 'undefined' || o.lat > n) {
                    n = o.lat;
                }
                if (typeof s === 'undefined' || o.lat < s) {
                    s = o.lat;
                }
                if (typeof e === 'undefined' || o.lng > e) {
                    e = o.lng;
                }
                if (typeof w === 'undefined' || o.lng < w) {
                    w = o.lng;
                }
            });

            map.bounds = {
                northeast: {
                    longitude: e,
                    latitude: n,
                },
                southwest: {
                    longitude: w,
                    latitude: s,
                },
            };

            return map.bounds;
        }

        function panTo(lat, lng) {
            control.panTo({
                lat: lat,
                lng: lng,
            });
        }

        function set(m) {
            map = m;
            control = m.control.getGMap();
        }

        function get() {
            return control;
        }

        function defaults(settings) {
            var options = {
                /**
                 * Map center
                 */
                center: {
                    latitude: 52.173931692568,
                    longitude: 18.8525390625,
                },
                /**
                 * Zoom level
                 */
                zoom: 3,
                bounds: {},
                /**
                 * Direct control
                 */
                control: {},
                /**
                 * Events
                 */
                events: {},
                overlays: [],
                marker: null,
                object: null,
                /**
                 * Other options
                 */
                options: {
                    controlSize: 32,
                    gestureHandling: 'greedy',

                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        position: 11,
                    },
                    fullscreenControl: true,
                    fullscreenControlOptions: {
                        position: 9,
                    },
                    zoomControl: true,
                    zoomControlOptions: {
                        position: 9,
                    },
                    scaleControl: false,
                    streetViewControl: false,
                },
            };

            if (settings === void 0) {
                settings = [];
            }

            if (settings.indexOf('cluster') >= 0) {
                var origin = location.protocol + '//' + location.host;
                var styles = [
                    {
                        height: 53,
                        url: origin + '/img/icons/clusters/m1.png',
                        width: 53,
                    },
                    {
                        height: 56,
                        url: origin + '/img/icons/clusters/m2.png',
                        width: 56,
                    },
                    {
                        height: 66,
                        url: origin + '/img/icons/clusters/m3.png',
                        width: 66,
                    },
                    {
                        height: 78,
                        url: origin + '/img/icons/clusters/m4.png',
                        width: 78,
                    },
                    {
                        height: 90,
                        url: origin + '/img/icons/clusters/m5.png',
                        width: 90,
                    },
                ];

                var cluster = {
                    type: 'cluster',
                    cluster: {
                        gridSize: 60,
                        minimumClusterSize: 2,
                        maxZoom: 13,
                        zoomOnClick: true,
                        imagePath:
                            'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                        styles: styles,
                    },
                };

                angular.extend(options, cluster);
            }

            return options;
        }

        /**
         * Converts latitude, longitude to a point on the map projection.
         *
         * @param {float} lat
         * @param {float} lng
         */
        function latLngToPoint(lat, lng) {
            var latLng = new google.maps.LatLng(lat, lng);
            return get()
                .getProjection()
                .fromLatLngToPoint(latLng);
        }

        /**
         * Offset a point with given latitude and longitude by X any Y pixels.
         *
         * @param {float} lat
         * @param {float} lng
         * @param {int} x
         * @param {int} y
         * @param {int} zoom
         */
        function getOffset(lat, lng, x, y, zoom) {
            if (zoom === false || zoom === void 0) {
                zoom = GoogleMapService.getZoom();
            }

            var scale = getScale(zoom);
            var coordinates = latLngToPoint(lat, lng);
            var pixel = new google.maps.Point(x / scale || 0, y / scale || 0);
            var offseted = new google.maps.Point(coordinates.x - pixel.x, coordinates.y + pixel.y);

            return get()
                .getProjection()
                .fromPointToLatLng(offseted);
        }

        /**
         * Return the map scale
         *
         * @param {int} zoom
         */
        function getScale(zoom) {
            return Math.pow(2, zoom);
        }

        /**
         * Get bounds
         */
        function getBounds(lat, lng) {
            var width = 60;
            var scale = getScale(getZoom());

            var position = latLngToPoint(lat, lng);
            return {
                left: position.x * scale - width / 2,
                top: position.y * scale - width / 2,
                right: position.x * scale + width / 2,
                bottom: position.y * scale + width / 2,
            };
        }

        function getWindowOffset(lat, lng, container) {
            var y = 0;
            var owHeight = angular.element(container).height();

            if (!isNaN(owHeight)) {
                y = -Math.round(owHeight / 2);
            }

            return getOffset(lat, lng, 0, y, getZoom());
        }
    }
})();
